import { render, staticRenderFns } from "./RoundedCheckbox.vue?vue&type=template&id=3a1b1975"
import script from "./RoundedCheckbox.vue?vue&type=script&lang=js"
export * from "./RoundedCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports